export default "__VITE_ASSET__dp9TwVDL__"